import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const LicenseDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add License"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="License">
                {getFieldDecorator('license', {
                 initialValue: data.license,
                  rules: [{ required: true, message: 'Please input the License!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default LicenseDialogForm;
